import React from 'react';
import { Variant, Color } from './types';

import * as S from './styles';

type Props = {
  count: number;
  hide?: boolean;
  variant?: Variant;
  color?: Color;
};

const Counter = ({
  count,
  hide = false,
  variant = Variant.LIGHT,
  color = Color.PRIMARY,
}: Props) => {
  if (hide) {
    return null;
  }
  return (
    <S.Counter variant={variant} color={color}>
      {count}
    </S.Counter>
  );
};

export default Counter;
